export default __webpack_public_path__ + "static/media/kollition_cut.90ebe682.jpg";